const hostnameToEnvKey: Record<string, string> = {
  'portal-dev.sitecore-staging.cloud': 'dev',
  'portal-qa.sitecore-staging.cloud': 'qa',
  'portal-staging.sitecore-staging.cloud': 'staging',
  'portal-preprod.sitecorecloud.io': 'preprod',
  'portal-beta.sitecorecloud.io': 'preprod',
  'portal.sitecorecloud.io': 'prod',
};

const DEFAULT_ENV_KEY = 'staging';

export const getEnvironmentFromUrl = (): string => {
  const currentHostname = window.location.hostname;
  return hostnameToEnvKey[currentHostname] || DEFAULT_ENV_KEY;
};

const hostnameToDeployUrl: Record<string, string> = {
  'portal-dev.sitecore-staging.cloud':
    'https://deploy-dev.sitecore-staging.cloud',
  'portal-qa.sitecore-staging.cloud':
    'https://deploy-qa.sitecore-staging.cloud',
  'portal-staging.sitecore-staging.cloud':
    'https://deploy-staging.sitecore-staging.cloud',
  'portal-preprod.sitecorecloud.io': 'https://deploy-preprod.sitecorecloud.io',
  'portal-beta.sitecorecloud.io': 'https://deploy-preprod.sitecorecloud.io',
  'portal.sitecorecloud.io': 'https://deploy.sitecorecloud.io',
};
const DEFAULT_DEPLOY_URL = 'https://deploy-staging.sitecore-staging.cloud';

export const getDeployBaseUrl = (): string => {
  const currentHostname = window.location.hostname;
  return hostnameToDeployUrl[currentHostname] || DEFAULT_DEPLOY_URL;
};
